import { CLEAR_ORDERS, GET_ORDERS } from 'modules/v2/store/constants';

export const clearOrders = () => ({
  type: CLEAR_ORDERS,
});

export const getOrders = () => ({
  type: GET_ORDERS,
});
